import { SagaIterator } from 'redux-saga';
import { call, put } from 'redux-saga/effects';
import { Messages } from '../../../../codegen/Localize';
import { IDataSourceDetailInfo } from '../../../../ts/models/IDataSourceInfo';
import { DataSources } from '../../../../ts/resources/Datasources';
import { ContentActions } from '../../../../ts/services/ContentActions';
import { ServerService } from '../../../../ts/services/ServerService';
import { WindowLocationService } from '../../../../ts/services/WindowLocationService';
import { requestFailed } from '../../../actions/RequestFailedAction';
import { NewWorkbookForDatasourceAction } from '../../../actions/spaces/NewWorkbookForDatasourceAction';
import { ServiceLocator } from '../../../ServiceLocator';
import { getDatasourceDetailInfo, openBlankWindow, replaceDatasourceIdWithConnectionIdForMixedContent } from '../SpacesSagaHelpers';

// When a new window is created, if it's not part of a click event handler it will be detected by browsers as a pop-up.
// Because we are opening a new window in the edit workbook saga which is async, to get around the pop up blocker we need
// to open the window first, then the window.location.href can be set asynchronously afterwards

export function* handleNewWorkbookForDatasourceAction(action: NewWorkbookForDatasourceAction): SagaIterator {
  let newWindow: Window = null;
  try {
    newWindow = openBlankWindow();
    const mutatableContentInfo = yield call(replaceDatasourceIdWithConnectionIdForMixedContent, [action.contentInfo]);
    const datasourceDetailInfo = yield call(getDatasourceDetailInfo, mutatableContentInfo[0].id);
    createNewWorkbookForDatasource(datasourceDetailInfo, newWindow);
  } catch(e) {
    newWindow && newWindow.close();
    yield put(requestFailed(e, Messages.errorUnknown()));
  }
}

function createNewWorkbookForDatasource(datasourceDetailInfo: IDataSourceDetailInfo, newWindow: Window) {
  const contentActionsService = ServiceLocator.get<ContentActions>('ContentActions');
  const serverService = ServiceLocator.get<ServerService>('ServerService');
  newWindow.location.href = contentActionsService.generateNewWorkbookFromDatasourceUrl(datasourceDetailInfo, serverService.sessionSiteUrlName());
}
